module.exports = __webpack_public_path__ + "img/C1.e1920569.jpg";